const REVIEW_TYPE_JSON = {
  '点图发声':'1',
  '角色扮演':'2',
  '图片选择题(横)':'3',
  '文字选择题':'4',
  '微动画':'5',
  'H5游戏':'6',
  '跳转外链':'7',
  '游戏模式':'8',
  '文字泛红':'9',
  '图片选择题(竖)':'10',
  '视频点播':'11',
  'H5微动画':'13'
}

module.exports = REVIEW_TYPE_JSON;